import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

@Component({
    selector: 'app-reach-out-splide',
    templateUrl: './reach-out-splide.component.html',
    styleUrls: ['./reach-out-splide.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReachOutSplideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const splide2 = new Splide( '.splide_2', {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 2,
      arrows: false,
      pagination: false,
      // direction: "rtl",
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
      },
      breakpoints: {
        
        480: {
          perPage: 1,
        },
      }
    } );

    splide2.mount( { AutoScroll } );

  }

}
